
<main [@fadeInOut] id="main-heading" role="main" tabindex="0">
    <div class="container-fluid padding-bottom-small">
    <div class="col-sm-11 center-block">
        <div *ngIf="!loading">
            <div class="row">
                <div class="col-sm-12">
                    <h1 tabindex="0" role="heading" aria-level="1">Establishment Registrations (ER)</h1>
                    <p tabindex="0" role="paragraph">
                        You can create a new Establishment Registrations form, find an existing form,
                        or browse through all the forms you have in the system with the helpful
                        grid below.
                    </p>
                    <p id="demo"></p>
                </div>
            </div>
            <div class="row top-space">
                <div class="col-sm-12 top-space">
                    <nav ngbNav #ngbNav="ngbNav" [(activeId)]="activeTab" (navChange)="tabChanged($event)" class="nav-tabs">
                        <ng-container ngbNavItem="ERFormGrid">
                            <a ngbNavLink>
                                <span [attr.aria-label]="count_ERForm + ' ER Forms'">ER ({{ count_ERForm }})</span>
                            </a>
                            <ng-template ngbNavContent>
                                <div class="row bottom-padding">
                                    <div class="col-sm-12">
                                        <ejs-tooltip #tooltipER id="tooltipER" (beforeRender)="tooltipValue($event)"
                                            target=".e-tooltipcolumn" [enableHtmlParse]="false">
                                            <ejs-grid id='ER_Form_Grid' #ERForm_grid [dataSource]='ERForm_grid_data'
                                                allowPaging='true' allowSorting='true' [pageSettings]='initialPage'
                                                height="570" (actionBegin)="begin($event)" [toolbar]='toolbarOptions'
                                                allowScrolling="true" allowFiltering="true"
                                                (rowSelected)="erFormGridRowSelected($event)"
                                                (rowDeselected)="erFormGridRowDeselected($event)"                                                
                                                (toolbarClick)='toolbarClick($event)'
                                                [selectionSettings]="{ type: 'Single', persistSelection: true }">
                                              <e-columns>
                                                <e-column field='erRevisionId'
                                                          isPrimaryKey="true"
                                                          [visible]="false"
                                                          [allowFiltering]="false"
                                                          [allowSorting]="false"></e-column>
                                                <e-column type="checkbox" width="40" *ngIf="hasDeletePermission">
                                                </e-column>
                                                <e-column [customAttributes]="clipmodecolumn" field='formName'
                                                          headerText='Form Name' clipMode="EllipsisWithTooltip"
                                                          width='300'>
                                                  <ng-template #template let-ERForm_grid_data>
                                                    <a class='pointer'
                                                       tabindex="0" role="link"
                                                       (keydown.enter)="viewERForm(ERForm_grid_data.erRevisionId)"
                                                       (click)='viewERForm(ERForm_grid_data.erRevisionId)'>
                                                      {{ERForm_grid_data.formName}}
                                                    </a>
                                                  </ng-template>
                                                </e-column>
                                                <e-column [customAttributes]="clipmodecolumn"
                                                          field='businessCategory' headerText='Business Category'
                                                          clipMode="EllipsisWithTooltip" width='260'></e-column>
                                                <e-column [customAttributes]="clipmodecolumn" field='formVersion'
                                                          headerText='Form Version' type="number" format="N1"
                                                          clipMode="EllipsisWithTooltip" width='130'></e-column>
                                                <e-column [customAttributes]="clipmodecolumn" field='modifiedBy'
                                                          headerText='Modified By' clipMode="EllipsisWithTooltip"
                                                          width='190'></e-column>
                                                <e-column [customAttributes]="clipmodecolumn"
                                                          [allowFiltering]="false" field='formatedModifiedDate'
                                                          headerText='Modified On' type="date" [format]='formatOptions'
                                                          clipMode="EllipsisWithTooltip" width='150'></e-column>
                                              </e-columns>
                                            </ejs-grid>
                                        </ejs-tooltip>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-container>
                        <ng-container ngbNavItem="drafts">
                            <a ngbNavLink>
                                <span [attr.aria-label]="count_draftERForm + ' Drafts'">Drafts ({{ count_draftERForm }})</span>
                            </a>
                            <ng-template ngbNavContent>
                              <div [@fadeInOut] class="row bottom-padding">
                                <div class="col-sm-12">
                                  <ejs-tooltip #tooltipDrafts id="tooltipDrafts"
                                               (beforeRender)="tooltipValue($event)" target=".e-tooltipcolumn"
                                               [enableHtmlParse]="false">
                                    <ejs-grid id='draftsGrid' #drafts_grid [dataSource]='ERDraftForm_grid_data'
                                              allowPaging='true' allowSorting='true' [pageSettings]='initialPage'
                                              height="570" (actionBegin)=begin($event) [toolbar]='toolbarOptions'
                                              allowScrolling="true" allowFiltering="true"
                                              (rowSelected)="erFormGridRowSelected($event)"
                                              (rowDeselected)="erFormGridRowDeselected($event)"                                              
                                              (toolbarClick)='toolbarClick($event)'
                                              [selectionSettings]="{ type: 'Single', persistSelection: true }">
                                      <e-columns>
                                        <e-column type="checkbox" width="40" *ngIf="hasDeletePermission">
                                        </e-column>
                                        <e-column field='erRevisionId'
                                                  isPrimaryKey="true"
                                                  [visible]="false"
                                                  [allowFiltering]="false"
                                                  [allowSorting]="false"></e-column>
                                        <e-column [customAttributes]="clipmodecolumn" field='formName'
                                                  headerText='Form Name' clipMode="EllipsisWithTooltip"
                                                  width='300'>
                                          <ng-template #template let-ERForm_grid_data>
                                            <a class='pointer'
                                               tabindex="0" role="link"
                                               (keydown.enter)="viewERForm(ERForm_grid_data.erRevisionId)"
                                               (click)='viewERForm(ERForm_grid_data.erRevisionId)'>{{ERForm_grid_data.formName}}</a>
                                          </ng-template>
                                        </e-column>
                                        <e-column [customAttributes]="clipmodecolumn"
                                                  field='businessCategory' headerText='Business Category'
                                                  clipMode="EllipsisWithTooltip" width='260'></e-column>

                                        <e-column [customAttributes]="clipmodecolumn" field='modifiedBy'
                                                  headerText='Modified By' clipMode="EllipsisWithTooltip"
                                                  width='190'></e-column>
                                        <e-column [customAttributes]="clipmodecolumn"
                                                  field='formatedModifiedDate' [allowFiltering]="false"
                                                  headerText='Modified On' type="date" [format]='formatOptions'
                                                  clipMode="EllipsisWithTooltip" width='150'></e-column>
                                      </e-columns>
                                    </ejs-grid>
                                  </ejs-tooltip>
                                </div>
                              </div>
                            </ng-template>
                        </ng-container>
                        <ng-container ngbNavItem="deliveries">
                            <a ngbNavLink>
                                <span [attr.aria-label]="count_deliveriesERForm + ' ER Deliveries'">ER Deliveries ({{ count_deliveriesERForm }})</span>
                            </a>
                            <ng-template ngbNavContent>
                                <div [@fadeInOut] class="row bottom-padding">
                                    <div class="col-sm-12">
                                        <ejs-tooltip #tooltipDeliveries id="tooltipDeliveries"
                                            (beforeRender)="tooltipValue($event)" target=".e-tooltipcolumn"
                                            [enableHtmlParse]="false">
                                            <ejs-grid id='deliveriesGrid' #deliveries_grid
                                                [dataSource]='ERDeliveries_grid_data' allowPaging='true'
                                                allowSorting='true' [pageSettings]='initialPage' height="570"
                                                (actionBegin)=begin($event) [toolbar]='toolbarOptions'
                                                allowScrolling="true" allowFiltering="true"
                                                (rowSelected)="erFormGridRowSelected($event)"
                                                (rowDeselected)="erFormGridRowDeselected($event)"                                               
                                                (toolbarClick)='toolbarClick($event)'
                                                       [selectionSettings]="{ type: 'Single', persistSelection: true }">
                                              <e-columns>
                                                <e-column type="checkbox" width="40">
                                                </e-column>
                                                <e-column field='erRevisionId'
                                                          isPrimaryKey="true"
                                                          [visible]="false"
                                                          [allowFiltering]="false"
                                                          [allowSorting]="false"></e-column>
                                                <e-column [customAttributes]="clipmodecolumn" field='status'
                                                          headerText='Status' clipMode="EllipsisWithTooltip" width='120'>
                                                </e-column>
                                                <e-column [customAttributes]="clipmodecolumn" field='formName'
                                                          headerText='Form Name' clipMode="EllipsisWithTooltip"
                                                          width='300'>
                                                  <ng-template #template let-ERDeliveries_grid_data>
                                                    <a class='pointer' tabindex="0" role="link"
                                                       (keydown.enter)="viewERForm(ERDeliveries_grid_data.erRevisionId)"
                                                       (click)='viewERForm(ERDeliveries_grid_data.erRevisionId)'>{{ERDeliveries_grid_data.formName}}</a>
                                                  </ng-template>
                                                </e-column>
                                                <e-column [customAttributes]="clipmodecolumn" headerText='File Name'
                                                          clipMode="EllipsisWithTooltip" width='300' field='fileName'>
                                                  <ng-template #template let-ERDeliveries_grid_data>
                                                    <a class='pointer underline' tabindex="0" role="link"
                                                       (keydown.enter)="downloadFile(ERDeliveries_grid_data.filePath, ERDeliveries_grid_data.fileName)"
                                                       (click)='downloadFile(ERDeliveries_grid_data.filePath, ERDeliveries_grid_data.fileName)'>
                                                      <i class="fas fa-download"
                                                         title="Download the file"></i>&nbsp;{{ERDeliveries_grid_data.fileName}}
                                                    </a>
                                                  </ng-template>
                                                </e-column>
                                                <e-column [customAttributes]="clipmodecolumn" field='pragmaticValidationStatus' headerText='Pragmatic Validation' clipMode="EllipsisWithTooltip" width='250'>
                                                  <ng-template #template let-data>
                                                    <app-pragmatic-grid-column [data]="data" (onDownload)="downloadFile($event.filePath, $event.fileName)"></app-pragmatic-grid-column>
                                                  </ng-template>
                                                </e-column>
                                                <e-column [customAttributes]="clipmodecolumn"
                                                          field='businessCategory' headerText='Business Category'
                                                          clipMode="EllipsisWithTooltip" width='260'></e-column>
                                                <e-column [customAttributes]="clipmodecolumn" field='formVersion'
                                                          headerText='Form Version' type="number" format="N1" width='130'>
                                                </e-column>
                                                <e-column [customAttributes]="clipmodecolumn" field='modifiedBy'
                                                          headerText='Modified By' clipMode="EllipsisWithTooltip"
                                                          width='190'></e-column>
                                                <e-column [customAttributes]="clipmodecolumn"
                                                          field='formatedModifiedOn' [allowFiltering]="false"
                                                          headerText='Modified On' type="date" [format]='formatOptions'
                                                          clipMode="EllipsisWithTooltip" width='150'></e-column>
                                              </e-columns>
                                            </ejs-grid>
                                        </ejs-tooltip>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-container>
                    </nav>
                    <div [ngbNavOutlet]="ngbNav"></div>
                </div>
            </div>
        </div>
        <div *ngIf="loading">
            <div id="loading"></div>
        </div>
        <div *ngIf="hasDeletePermission" class="col-sm-12 grid-actions">
            <app-delete-button class="hide-element" #deleteERButton [canDelete]="!!selectedErRevisionId"
                [revisionId]="selectedErRevisionId" [apiController]="'ERForms'" [isDraft]="false">
            </app-delete-button>
        </div>
        <div *ngIf="hasDeletePermission" class="col-sm-12 grid-actions">
            <app-delete-button class="hide-element" #deleteERDraftButton [canDelete]="!!selectedErRevisionId"
                [revisionId]="selectedErRevisionId" [apiController]="'ERForms'" [isDraft]="true">
            </app-delete-button>
        </div>
        <div *ngIf="hasDeletePermission" class="col-sm-12 grid-actions">
            <app-delete-button class="hide-element" #deleteERDeliveryButton [canDelete]="!!selectedErRevisionId"
                [revisionId]="selectedErRevisionId" [apiController]="'ERForms'" [isDelivery]="true">
            </app-delete-button>
        </div>
    </div>
    </div>

    <div class="sendToFDADiv hide-element">
        <app-esig-modal #sendToFDAButton [fileName]="'' + selectedERRevisionFileName"
            [documentType]="'' + selectedERRevisionProductType" [splVersionNumber]="'' + selectedERRevisionVersion"
            [formRevisionId]="'' + selectedErRevisionId" [orderId]="" (isSuccessfulySubmitted)="onSubmitionToFDA($event)">
        </app-esig-modal>
    </div>
</main>
